import { Grid, Typography } from '@mui/material';
import { styles } from './styles';
import type { CSSProperties } from 'react';
import { SystemStyleObject, Theme } from '@mui/system';

interface ITableHeaderProps {
  columns: { size: number; title: string }[];
  showActions?: boolean;
  position?: CSSProperties['position'];
}

export const TableHeader = ({ columns, showActions, position = 'sticky' }: ITableHeaderProps) => {
  return (
    <Grid container sx={[styles.header as SystemStyleObject<Theme>, { position: position }]}>
      {columns.map((column) => (
        <Grid
          size={column.size}
          key={column.title}
          sx={(theme) => ({ ...styles.headerItem(theme), ...styles.item(theme) })}
        >
          <Typography variant="body2" noWrap sx={{ pr: 0.2 }}>
            {column.title}
          </Typography>
        </Grid>
      ))}

      {showActions && (
        <Grid size={1} sx={(theme) => ({ ...styles.headerItem(theme), ...styles.item(theme) })}>
          <Typography variant="body2">Дії</Typography>
        </Grid>
      )}
    </Grid>
  );
};
